// extracted by mini-css-extract-plugin
module.exports = {"content":"Home_content__ZLoWn"};